import React from 'react'
import '../assets/css/ticTacToeStyles.css'

class Board extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      ...this.setInitialValues()
    }
  }
  setInitialValues() {
    return {
      squares: Array(9).fill(null),
      xIsNext: true
    }
  }
  handleClick(i) {
    // .slice() to create a copy of the squares array to modify instead of modifying the existing array
    const squares = this.state.squares.slice()

    if (calculateWinner(squares) || squares[i]) return

    squares[i] = this.state.xIsNext ? 'X' : 'O'
    this.setState({ 
      squares: squares,
      xIsNext: !this.state.xIsNext
    })
  }
  renderSquare(i) {
    return (
      <Square
        value={this.state.squares[i]}
        onClick={() => this.handleClick(i)}
      />
    )
  }

  reset() {
    this.setState({ 
      ...this.setInitialValues()
    })
  }

  render() {
    const winner = calculateWinner(this.state.squares)

    let status 

    if (winner) 
      status = `Winner is ${winner}`
    else 
      status = `Next player: ${this.state.xIsNext ? 'X' : 'O'}`

    const resetBtnStyles = {
      margin: '2% 0 10% 0',
      backgroundColor: 'blue',
      color: 'white'
    }

    return (
      <div>
        <div className="status">{status}</div>
        <button
          id="reset-button"
          onClick={() => this.reset()}
          style={resetBtnStyles}
        >
          Reset
        </button>
        <div className="board-row">
          {this.renderSquare(0)}
          {this.renderSquare(1)}
          {this.renderSquare(2)}
        </div>
        <div className="board-row">
          {this.renderSquare(3)}
          {this.renderSquare(4)}
          {this.renderSquare(5)}
        </div>
        <div className="board-row">
          {this.renderSquare(6)}
          {this.renderSquare(7)}
          {this.renderSquare(8)}
        </div>
      </div>
    )
  }
}

function Square(props) {
  // In JavaScript classes, you need to always call 
  // super when defining the constructor of a subclass. 
  // All React component classes that have a constructor should start with a super(props) call.
  //  constructor(props) {
  //    super(props)
  //    this.state = {
  //      value: null
  //    }
  //  }
  //  render() {
  
  return (
    <button
      className="square"
      onClick={props.onClick}
    >
      {props.value}
    </button>
  )
}
//  }

class Game extends React.Component {
  componentDidMount() {
    document.title = 'My first Tic Tac Toe using React.js'
  }
  render() {
    
    // squares={current.squares}
    // onClick={(i) => this.handleClick(i)}
    return (
      <div className="game">
        <div className="game-board">
          <Board />
        </div>
        <div className="game-info">
          <div>
            {/* status */}
          </div>
          <ol>
            {/* TODO */}
          </ol>
        </div>
      </div>
    )
  }
}

function calculateWinner(squares) {
  const lines = [
    [0,1,2],
    [3,4,5],
    [6,7,8],
    [0,3,6],
    [1,4,7],
    [2,5,8],
    [0,4,8],
    [2,4,6]
  ]
  
  for (let i = 0; i < lines.length; i++) {
    const [a,b,c] = lines[i]
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      return squares[a]
    }
  }
  return null
}

export default Game